import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./promo/promo-landing/promo-landing.component')
      .then(m => m.PromoLandingComponent),
    title: 'ArtFlow Enhancer - Free AI Image Enhancement for Artists'
  },
  {
    path: 'editor',
    loadComponent: () => import('./editor-page/editor-page.component')
      .then(m => m.EditorPageComponent),
    title: 'Image Editor - ArtFlow Enhancer'
  },
  {
    path: 'gallery',
    loadComponent: () => import('./public-gallery/public-gallery-page.component')
      .then(m => m.PublicGalleryPageComponent),
    title: 'Community Gallery - ArtFlow Enhancer'
  },
  {
    path: 'confirm',
    loadComponent: () => import('./confirm-email/confirm-email.component')
      .then(m => m.ConfirmEmailComponent),
    title: 'Confirm Email - ArtFlow Enhancer'
  },
  {
    path: 'dev/gallery-moderation',
    loadComponent: () => import('./dev/gallery-moderation/gallery-moderation.component')
      .then(m => m.GalleryModerationComponent),
    title: 'Gallery Moderation - ArtFlow Enhancer'
  },
  {
    path: 'dev/settings',
    loadComponent: () => import('./dev/admin-settings/admin-settings.component')
      .then(m => m.AdminSettingsComponent),
    title: 'Admin Settings - ArtFlow Enhancer'
  },
  {
    path: '**',
    redirectTo: ''
  }
];
